import { render, staticRenderFns } from "./AddressRow.vue?vue&type=template&id=6882cf07&scoped=true&"
import script from "./AddressRow.vue?vue&type=script&lang=js&"
export * from "./AddressRow.vue?vue&type=script&lang=js&"
import style0 from "./AddressRow.vue?vue&type=style&index=0&id=6882cf07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6882cf07",
  null
  
)

export default component.exports